export { default } from './StatisticsItem.js';
